type FeedbackAssistantInitOptions = {
  token: string
  getUserToken?: () => string | null | undefined
  routeMode?: 'history' | 'hash'
  ignorePaths?: Array<string | RegExp>
}

declare global {
  interface Window {
    TechforceFeedbackAssistant?: {
      init: (options: FeedbackAssistantInitOptions) => void
    }
  }
}

//const DEV_FEEDBACK_ASSISTANT_TOKEN = 'fba_s6jE3maJWTGQnUYwwNY_jKWZgX2S_CHFTri4hCdkg08'
const DEV_FEEDBACK_ASSISTANT_TOKEN = 'fba_DdjzkwlVbmw-KRq2cw6PRJZbZP1J4Tyjb15sY7t-Mf0'
const PROD_FEEDBACK_ASSISTANT_TOKEN = 'fba_H3dxc9K6n_82KRNgP1RWFlwCu3vvEaEjOZtij8NE-uk'

const feedbackAssistantToken =
  import.meta.env.VITE_FEEDBACK_ASSISTANT_TOKEN ||
  (import.meta.env.DEV ? DEV_FEEDBACK_ASSISTANT_TOKEN : PROD_FEEDBACK_ASSISTANT_TOKEN)

function getFeedbackUserToken(): string | null {
  try {
    const user = JSON.parse(window.localStorage.getItem('user') || '{}')
    return user.id != null ? String(user.id) : window.localStorage.getItem('userToken')
  } catch (error) {
    return window.localStorage.getItem('userToken')
  }
}

window.TechforceFeedbackAssistant?.init({
  token: feedbackAssistantToken,
  getUserToken: getFeedbackUserToken,
  routeMode: 'history',
  ignorePaths: ['/login']
})
